'use client'

const brands = [
  'TechCorp', 'FinEdge', 'ShopNova', 'MediCare+', 'LogiFlow',
  'EduSphere', 'RealtyPulse', 'CloudNine', 'DataForge', 'NexaBank',
]

export default function LogoMarquee() {
  // Duplicate the list so the track can loop seamlessly.
  const row = [...brands, ...brands]

  return (
    <section className="py-14 bg-white border-y border-slate-100 overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 mb-8">
        <p className="text-center text-sm font-medium uppercase tracking-widest text-slate-400">
          Trusted by teams at
        </p>
      </div>

      <div className="relative">
        {/* edge fades */}
        <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-white to-transparent z-10" />
        <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-white to-transparent z-10" />

        <div className="marquee-track flex items-center gap-16 w-max">
          {row.map((brand, i) => (
            <span
              key={i}
              className="text-2xl font-bold text-slate-300 hover:text-sky-500 transition-colors whitespace-nowrap select-none"
            >
              {brand}
            </span>
          ))}
        </div>
      </div>

      <style jsx>{`
        .marquee-track {
          animation: marquee 28s linear infinite;
        }
        .marquee-track:hover {
          animation-play-state: paused;
        }
        @keyframes marquee {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
        @media (prefers-reduced-motion: reduce) {
          .marquee-track { animation: none; }
        }
      `}</style>
    </section>
  )
}
